if (!customElements.get('slideshow-swiper')) {
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    /**
     * 使用透明导航栏
     */
    useTransparentHeader;

    // 避免无限循环触发 slideTo：
    isSyncing = false;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      this.blocksSize = Number(this.getAttribute("data-blocks-size"));
      this.mobileContent = this.querySelector("[data-mobile-content]");

      const isMobile = `(max-width: 989px)`;
      const isMobileMQL = window.matchMedia(isMobile);
      this.isMobileMQL = isMobileMQL;
      isMobileMQL.addEventListener('change', (event) => {
        if (event.matches) {
          this.createMobileSlider();
        }
      });
      if (this.isMobileMQL.matches) {
        setTimeout(() => {
          this.createMobileSlider();
        }, 1);
      }
    }

    connectedCallback() {
      this.mySwiper = new Swiper(this.querySelector(`[data-swiper-main]`), {
        // effect: 'fade',
        loop: true,
        autoplay: {
          delay: 8000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        // autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
        //   delay: this.sectionSettings.autoplay_speed * 1000,
        //   pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        // },
        spaceBetween: 8,
        autoHeight: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        // navigation: {
        //   nextEl: `#${this.id} .swiper-btn-next`,
        //   prevEl: `#${this.id} .swiper-btn-prev`,
        // },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        on: {
          // slideChange: (swiper) => {
          //   if (this.isSyncing) return;
          //   const index = swiper.realIndex;
          //   if (this.mbSwiper) {
          //     this.isSyncing = true;
          //     this.mbSwiper.slideToLoop(index);
          //     this.isSyncing = false;
          //   }
          // },
        },
        breakpoints: {
          990: {
            // effect: 'slide',
            spaceBetween: 0,
          },
        },
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }
    }

    firstInitMobileSliderContent() {
      let innerHTML = ``;
      const overlayElements = this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) .slideshow-swiper__overlay-wrapper');
      console.log(overlayElements, '123')
      for (const overlay of overlayElements) {
        innerHTML += `<div class="swiper-slide">${overlay.outerHTML}</div>`;
      }
      this.mobileContent.innerHTML = innerHTML;
    }

    createMobileSlider() {
      this.mbSwiper = new Swiper(this.querySelector(`[data-swiper-secondary]`), {
        effect: 'fade',
        loop: true,
        thumbs: {
          swiper: this.mySwiper,
        },
        allowTouchMove: false,
        autoHeight: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        on: {
          slideChange: (swiper) => {
            if (this.isSyncing) return;
            const index = swiper.realIndex;
            if (this.mySwiper) {
              // console.log('slideChange2')
              this.isSyncing = true;
              this.mySwiper.slideToLoop(index)
              this.isSyncing = false;
            }
          },
        },
      });
    }

  }

  customElements.define('slideshow-swiper', SlideshowSwiper);
}